import { render, staticRenderFns } from "./BirthdayDetail.vue?vue&type=template&id=20ea19ad"
import script from "./BirthdayDetail.vue?vue&type=script&lang=js"
export * from "./BirthdayDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports